import { useMutation } from '@tanstack/react-query'
import { timeTrackingApprove } from '@viterbit/web-app/dataAccess/service/timeTrackingService'

type TimeTrackingApproveConfig = {
    onSuccess?: () => void
    onError?: () => void
}

export const useTimeTrackingApprove = (config: TimeTrackingApproveConfig = {}) =>
    useMutation({
        ...config,
        mutationFn: timeTrackingApprove,
        onSuccess: config.onSuccess,
        onError: config.onError,
    })
